import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-two-pipe',
  templateUrl: './two-pipe.component.html',
  styleUrls: ['./two-pipe.component.scss']
})
export class TwoPipeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
